import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

const api = rootApi.injectEndpoints({
  endpoints: (build) => ({
    shareAvailability: build.mutation({
      query: (formData) => ({
        url: '/api/dashboard/contacts/share_availability',
        method: 'POST',
        data: formData,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      }),
      extraOptions: {
        onSuccess: (response, { dispatch }) => {
          dispatch(showSuccess(I18n.t('publisher.contacts.share.success_flash')))
        },
      },
    }),
  })
})

export const {
  useShareAvailabilityMutation
} = api
